import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROCESS } from "../mock";

export default function PhilosophySplit() {
  return (
    <section className="bg-bone py-24 lg:py-36 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-6 sticky top-28">
          <div className="relative aspect-[4/5] overflow-hidden img-wipe rv">
            <img
              src="https://images.unsplash.com/photo-1710883727427-59d1ccc368fa?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600"
              alt="Craftsmanship"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="hidden lg:block absolute -bottom-16 right-8 w-[240px] aspect-[3/4] overflow-hidden border-[10px] border-bone shadow-2xl">
            <img
              src="https://images.pexels.com/photos/4170184/pexels-photo-4170184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600"
              alt="" className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="text-eyebrow text-amber mb-5 rv">— 007 • The Philosophy</div>
          <h2 className="font-display-tight text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-ink text-balance mb-8 rv">
            A quiet studio.<br /><span className="italic font-display">The loudest homes.</span>
          </h2>
          <p className="text-ink-soft text-lg leading-relaxed mb-6 rv">
We are a UK-based construction and property improvement team, bringing together skilled tradespeople, designers, and project specialists to deliver reliable building, renovation, and installation services across homes and commercial spaces.          </p>
          <p className="text-ink-soft text-lg leading-relaxed mb-10 rv">
            Every client works directly with a senior partner. Every project has a dedicated site manager. Every detail, from the first consultation to the 24-month warranty check, is ours to get right.
          </p>

          {/* Process list */}
          <div className="border-t border-line rv">
            {PROCESS.map((p) => (
              <div key={p.step} className="grid grid-cols-12 gap-4 items-start border-b border-line py-6">
                <div className="col-span-2 text-eyebrow text-amber">{p.step}</div>
                <div className="col-span-10">
                  <div className="font-display text-2xl text-ink mb-1">{p.title}</div>
                  <p className="text-ink-soft leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <Link to="/about" className="mt-10 inline-flex items-center gap-3 group rv">
            <span className="h-12 w-12 border border-ink flex items-center justify-center group-hover:bg-amber group-hover:border-amber transition-colors">
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
            <span className="text-eyebrow text-ink link-line">Our Story</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
